<template>
  <div class="summary-chart">
    <apexchart
      :height="400"
      type="area"
      :options="chart.options"
      :series="series"
    />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import VueApexCharts from 'vue-apexcharts'

export default {
  props: ['series'],
  setup({ series }) {
    return {
      chart: {
        options: {
          chart: {
            id: 'vuechart-example',
            fontFamily: 'Roboto',
            foreColor: '#bababa',
            toolbar: {
              show: false,
              tools: {
                download: true,
                selection: false,
                zoom: false,
                zoomin: false,
                zoomout: false,
                pan: false,
                reset: false,
              },
            },
          },
          tooltip: {
            x: {
              type: 'datetime',
              format: 'ddd, MMM dd',
            },
          },
          xaxis: {
            type: 'datetime',
            labels: {
              format: 'ddd, MMM dd',
            },
          },
          yaxis: {
            forceNiceScale: true,
            decimalsInFloat: 0,
            min: 0,
            max(val) {
              return Math.round(val * 1.1) + 1
            },
            labels: {
              formatter: (val) => {
                if (val % 1 === 0) {
                  return val
                }
              },
            },
          },
        },
      },
    }
  },
}
</script>

<style lang="scss">
@import '~assets/css/colors.scss';
@import '~assets/css/vars.scss';
</style>
